/**
 * Cookie banner extras: close (X) declines non-essential cookies
 * (same outcome as Decline — does not accept analytics/marketing).
 */
(function () {
  const BANNER_ID = 'shopify-pc__banner';
  const CLOSE_CLASS = 'bf-cookie-banner-close';

  function declineNonEssential() {
    const declineBtn =
      document.getElementById('shopify-pc__banner__btn-decline') ||
      document.querySelector(
        '#shopify-pc__banner .shopify-pc__banner__btn-decline, #shopify-pc__banner .shopify-pc__banner_btn-decline'
      );

    if (declineBtn) {
      declineBtn.click();
      return;
    }

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) return;

        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: false,
            marketing: false,
            preferences: false,
          },
          function () {
            const banner = document.getElementById(BANNER_ID);
            if (banner) banner.style.display = 'none';
          }
        );
      }
    );
  }

  function injectCloseButton(banner) {
    if (!banner || banner.querySelector('.' + CLOSE_CLASS)) return;

    if (getComputedStyle(banner).position === 'static') {
      banner.style.position = 'fixed';
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = CLOSE_CLASS;
    button.setAttribute('aria-label', 'Close cookie banner');
    button.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M14 1.4 12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4 12.6 14 14 12.6 8.4 7z"/>' +
      '</svg>';

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      declineNonEssential();
    });

    banner.appendChild(button);
  }

  function scan() {
    injectCloseButton(document.getElementById(BANNER_ID));
  }

  scan();

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
